import {UserManager, WebStorageStateStore, Log} from 'oidc-client-ts'
import {IDENTITY_CONFIG, METADATA_OIDC} from '../utils/authConst'

export default class AuthService {
  UserManager
  constructor() {
    this.UserManager = new UserManager({
      ...IDENTITY_CONFIG,
      userStore: new WebStorageStateStore({store: window.sessionStorage}),
      stateStore: new WebStorageStateStore({store: window.sessionStorage}),
      metadata: {
        ...METADATA_OIDC,
      },
    })

    this.UserManager.events.addUserLoaded((user) => {
      if (window.location.href.includes('callback')) {
        this.navigateToScreen()
      }
    })

    this.UserManager.events.addAccessTokenExpired(() => {
      void this.signInSilent()
    })
  }

  signInRedirectCallback = (): any => {
    localStorage.setItem('Notify', 'Yes')
    localStorage.setItem('loggedIn Time', `${String(new Date())}`)
    return this.UserManager.signinRedirectCallback()
  }

  getUser = async (): Promise<any> => {
    const user = await this.UserManager.getUser()
    if (user == null) {
      return await this.UserManager.signinRedirectCallback()
    }
    return user
  }

  parseJwt = (token: string): any => {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64))
  }

  signInRedirect = async () => {
    localStorage.setItem('redirectUri', window.location.pathname)

    void this.UserManager.signinRedirect({})
  }

  navigateToScreen = (): void => {
    window.location.replace('/')
  }

  isAuthenticated = (): boolean => {
    const oidcStorage = localStorage.getItem(
      `oidc.user:${IDENTITY_CONFIG.authority ?? ''}:${IDENTITY_CONFIG.client_id ?? ''}`
    )

    if (oidcStorage != null) {
      const parsedStorage = JSON.parse(oidcStorage)
      return !!(Boolean(parsedStorage) && Boolean(parsedStorage.access_token))
    }

    return false
  }

  // createSignInRequest = (): any => {
  //   return this.UserManager.createSigninRequest()
  // }

  // Demo branch: local-only signout. No OIDC signoutRedirect, so the
  // identity-provider (SSO) session is left alone and there is no
  // /signout-callback-oidc round trip.
  logout = async (): Promise<void> => {
    localStorage.removeItem('loggedIn Time')
    localStorage.removeItem('Notify')
    localStorage.clear()
    sessionStorage.clear()

    await this.UserManager.removeUser()
    void this.UserManager.clearStaleState()
  }

  signInSilent = async (): Promise<void> => {
    try {
      const user = await this.UserManager.signinSilent({
        scope: IDENTITY_CONFIG.scope,
        // response_type: IDENTITY_CONFIG.response_type,
      })
    } catch (err) {
      await this.logout()
    }
  }

  signinSilentCallback = (): any => {
    void this.UserManager.signinSilentCallback()
  }

  signoutRedirectCallback = (): void => {
    this.UserManager.signoutRedirectCallback().then(() => {
      localStorage.clear()
      window.location.replace('/')
    })
    this.UserManager.clearStaleState()
  }

  getToken = (): string | null => {
    const oidcStorageString = localStorage.getItem(
      `oidc.user:${IDENTITY_CONFIG.authority ?? ''}:${IDENTITY_CONFIG.client_id ?? ''}`
    )
    const oidcStorage = oidcStorageString != null ? JSON.parse(oidcStorageString) : null
    return oidcStorage != null && Boolean(oidcStorage.access_token)
      ? oidcStorage.access_token
      : null
  }
}
